import UserModel from "src/models/UserModel";
import { AddUserFormValues } from "src/routes/admin/users/AddUser";
import { Level } from "types/code-generator";
import { UseFormHook } from "../forms/Form";
import InputRadio from "../inputs/InputRadio";

interface Props {
  onChange?: (value) => void;
  user: UserModel;
  form: UseFormHook<AddUserFormValues>;
}

export default function CaptynPermissions(props: Props) {
  const { form, user } = props;

  form.getFieldDecorator("level", {
    initialValue: user ? user.level : Level.Captyn,
  });

  return (
    <>
      <hr />
      <div>
        <InputRadio
          checked={form.getFieldValue("level") === Level.Captyn}
          disabled={form.isSubmitting}
          name="level"
          value={Level.Captyn}
          onChange={(value) => {
            form.setFieldsValue({
              level: value,
            });

            if (props.onChange) {
              props.onChange(value);
            }
          }}
          label={
            <>
              Regular User
              <div className="text-empty">
                Captyn account plus any connected subdomains only. No access to
                any super admin areas.
              </div>
            </>
          }
        />
      </div>
      <hr />
      <div>
        <InputRadio
          checked={form.getFieldValue("level") === Level.Sales}
          disabled={form.isSubmitting}
          name="level"
          value={Level.Sales}
          onChange={(value) => {
            form.setFieldsValue({
              level: value,
            });

            if (props.onChange) {
              props.onChange(value);
            }
          }}
          label={
            <>
              Salesperson
              <div className="text-empty">
                Access only to organizations when assigned as salesperson or
                account manager. No access to financial information, user data,
                import/export, or subdomain management.
              </div>
            </>
          }
        />
      </div>
      <hr />
      <div>
        <InputRadio
          checked={form.getFieldValue("level") === Level.SuperAdmin}
          disabled={form.isSubmitting}
          name="level"
          value={Level.SuperAdmin}
          onChange={(value) => {
            form.setFieldsValue({
              level: value,
            });

            if (props.onChange) {
              props.onChange(value);
            }
          }}
          label={
            <>
              Super Admin
              <div className="text-empty">
                Access to everything, including all domains and financial
                information.
              </div>
            </>
          }
        />
      </div>
      <hr />
    </>
  );
}
